import { QueryFunctionContext, useInfiniteQuery } from "@tanstack/react-query";
import { container } from "tsyringe";
import { INVITES } from "../../../constants/queryKey";
import { InviteService } from "../invite.service";

const getInvitesFn = async ({
  continuationToken
}: {
  continuationToken?: string;
}) => {
  const inviteService = container.resolve(InviteService);
  const { viewPage, continuationToken: nextContinuationToken } =
    await inviteService.getInvites(continuationToken);
  return { ...viewPage, continuationToken: nextContinuationToken };
};

export const useInvites = () => {
  return useInfiniteQuery({
    queryKey: [INVITES],
    queryFn: ({
      pageParam
    }: QueryFunctionContext<unknown[], string | undefined>) =>
      getInvitesFn({
        continuationToken: pageParam
      }),
    getNextPageParam: (lastPage) => lastPage.continuationToken,
    initialPageParam: undefined,
    refetchInterval: 30_000
  });
};
